import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const GetReportsSlice = createSlice({
    name: "getReports",
    initialState,
    reducers: {
        getReportsRequest(state) {
            state.loading = true;
        },
        getReportsRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        getReportsRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
    },
});

export const {
    getReportsRequest,
    getReportsRequestSuccess,
    getReportsRequestError,
} = GetReportsSlice.actions;

export default GetReportsSlice.reducer;
